import axios from 'axios';

const url = process.env.REACT_APP_BASE_API_URL;

export const sysparamFindBySysNome = async(sysNome) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/sysparam/findbysysnome/' + sysNome, {headers});
}

